// extracted by mini-css-extract-plugin
export var segmentText = "video-scroller-module--segmentText--Y1XwE";
export var textSide = "video-scroller-module--textSide--oiho1";
export var videoContainer = "video-scroller-module--videoContainer--shnIO";
export var videoLayer = "video-scroller-module--videoLayer--0Kn9R";
export var videoScrollerContainer = "video-scroller-module--videoScrollerContainer--27Rcs";
export var videoSide = "video-scroller-module--videoSide--0HcmW";